import { render, staticRenderFns } from "./EditContentChain.vue?vue&type=template&id=93b225d4&"
import script from "./EditContentChain.vue?vue&type=script&lang=js&"
export * from "./EditContentChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports